if (!customElements.get('announcement-marquee')) {
  customElements.define(
    'announcement-marquee',
    class AnnouncementMarquee extends HTMLElement {
      connectedCallback() {
        if (this.visibilityChangeHandler) return;

        this.visibilityChangeHandler = () => {
          this.toggleAttribute('data-document-hidden', document.hidden);
        };

        this.visibilityChangeHandler();
        document.addEventListener('visibilitychange', this.visibilityChangeHandler);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
      }
    }
  );
}
